import {
  // HomeDemo1Platform,
  HomeDemo1Rings,
} from "../../../utils/allImgs";

import SectionHeading from "../../../components/SectionHeading";
import { useTranslation } from "react-i18next";

const OurPlatform = ({ data }) => {
  const { t } = useTranslation();

  return (
    <section className="features section-padding-0-100 " id="about">
      <div className="container">
        <SectionHeading title={t('aboutUs')} text={t('title2')}/>

        <div className="row align-items-center">
          <div className="service-img-wrapper col-lg-7 col-md-12 col-sm-12 mt-s">
            <div className="image-box">
              <lottie-player
                src="https://assets6.lottiefiles.com/private_files/lf30_pvi8w5ye.json"
                background="transparent"
                speed="0.3"
                style={{ width: "100%", height: "100%" }}
                loop
                autoplay
              ></lottie-player>{" "}
              <img
                draggable="false"
                src={HomeDemo1Rings}
                className="center-block img-responsive rings "
                alt=""
              />
            </div>
          </div>
          <div className="service-img-wrapper col-lg-5 col-md-12 col-sm-12 no-padding-right">
            <div className="features-list">
              <div className="who-we-contant">
                <h4 className="w-text" data-aos="fade-up" data-aos-delay="200">
                {t('title3')} 
                </h4>
                <p className="w-text" data-aos="fade-up" data-aos-delay="300">
                {t('body1')} 
                </p>
              </div>
              <ul className="list-marked">
                {/* {data &&
                  data.map((item, key) => (
                    <li key={key} className="text-white">
                      <i className="fa fa-check" />
                      {item.icoName}
                    </li>
                  ))} */}
                   <li  className="text-white">
                      <i className="fa fa-check" />
                      {/* {item.icoName} */}
                      {t('list1')} 
                    </li>  <li  className="text-white">
                      <i className="fa fa-check" />
                      {/* {item.icoName} */}
                      {t('list2')} 
                    </li>  <li  className="text-white">
                      <i className="fa fa-check" />
                      {/* {item.icoName} */}
                      {t('list3')} 
                    </li>
              </ul>
              <a className="btn more-btn mt-30" href="#services">
              {t('button3')}               </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPlatform;
